import { type Common } from './common.js';
import { type Nullable } from './models/common.js';
import { type FlagMap, type FlagOptions, type Setting } from './models/featureFlag.js';

export class API {
  baseEndpoint = '/featureFlags';
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async me(): Promise<Setting[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/me`);
    const { settings } = await this.common.getJSON(url);
    return settings;
  }

  async get(
    userId: string,
    includeFlagDescriptions: true
  ): Promise<{ flags: FlagMap; flagDescriptions: FlagOptions }>;
  async get(userId: string): Promise<{ flags: FlagMap }>;
  async get(userId: string, includeFlagDescriptions?: true) {
    let url = this.common.constructPath(`/users/${userId}/featureFlags`);
    if (includeFlagDescriptions) {
      url = `${url}?includeFlagDescriptions=true`;
    }
    return await this.common.getJSON(url);
  }

  async set(userId: string, values: Partial<Nullable<FlagMap>>): Promise<{ flags: FlagMap }> {
    const url = this.common.constructPath(`/users/${userId}/featureFlags`);
    return await this.common.patchJSON(url, { flags: values });
  }

  async findAllByUserId(userId?: string): Promise<Setting[]> {
    const url = this.common.constructPath(`/users/${userId}/featureFlags/list`);
    return await this.common.getJSON(url);
  }
}
